import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
import { store } from "@/store";
import StoreGetter from "@/constants/StoreGetter";
import axios from "axios";

const UserService = {
  getUserById(obj) {
    return httpClient.post(endPoints.getUserById, obj);
  },
  getUsers(obj) {
    return httpClient.post(endPoints.getUsers, obj);
  },
  getUserTree(obj) {
    return httpClient.post(endPoints.getUserTree, obj);
  },
  getAllUsers(obj) {
    return httpClient.post(endPoints.getAllUsers, obj);
  },
  addUser(obj) {
    return httpClient.post(endPoints.addUser, obj);
  },
  updateUser(obj) {
    return httpClient.post(endPoints.updateUser, obj);
  },
  getSupervisorListForAddOrEdit(obj) {
    return httpClient.post(endPoints.getSupervisorListForAddOrEdit, obj);
  },
  deleteUser(obj) {
    return httpClient.post(endPoints.deleteUser, obj);
  },
  getUserLeaves(obj) {
    return httpClient.post(endPoints.getUserLeaves, obj);
  },
  getLeaveAttachments(obj) {
    return httpClient.post(endPoints.getLeaveAttachments, obj);
  },
  uploadAttachments(obj) {
    return httpClient.post(endPoints.uploadAttachments, obj);
  },
  checkLeaveTypeBalance(obj) {
    return httpClient.post(endPoints.checkLeaveTypeBalance, obj);
  },
  addLeave(obj) {
    return httpClient.post(endPoints.addLeaveApp, obj);
  },
  editLeave(obj) {
    return httpClient.post(endPoints.editLeaveApp, obj);
  },
  getLeaveEndDate(obj) {
    return httpClient.post(endPoints.getLeaveEndDate, obj);
  },
  adjustLeave(obj) {
    return httpClient.post(endPoints.adjustLeave, obj);
  },
  uploadProfileImage(obj) {
    return httpClient.post(endPoints.uploadProfileImage, obj);
  },
  deleteLeaveApp(obj) {
    return httpClient.post(endPoints.deleteLeaveApp, obj);
  },
  cancelLeaveApp(obj) {
    return httpClient.post(endPoints.cancelLeaveApp, obj);
  },
  deleteLeaveAppAttachments(obj) {
    return httpClient.post(endPoints.deleteLeaveAppAttachments, obj);
  },
  syncUserToMizar(obj) {
    const APISetting = {
      baseURL: obj.Url,
      timeout: 200000,
      headers: {
        "Content-Type": "application/json",
        "token": obj.AccessToken
      }
    };
    const compCode = store.getters[StoreGetter.serverRouter].CompCode;
    //const compCode = "TEST";
    const SyncUser = {
      syncUser: {
        CompCode: compCode,
        UserID: obj.user.UserID,
        UserName: obj.user.ChiName,
        Password: "123456",
        UserGroup: "",
        Mobile: obj.user.MobilePhone,
        Email: obj.user.Email,
        Language: obj.user.Lang,
        SupervisorID: obj.user.SupervisorID,
        StartDate: obj.user.DateJoin,
        EndDate: obj.user.DateResign,
        UserStatus: "Active",
        Deputy: obj.user.Acting,
        IsKioskUser: false,
        VwAllRec: false,
        ModAllRec: false,
        IsChatServerInitialized: false,
        DateAdd: new Date(),
        AddBy: "ELMS",
        DateModify: '1900-01-01',
        ModifyBy: "",
        RecDel: obj.user.RecDel,
      },
      b_delUser: obj.user.RecDel,
    }
    const serverRouterURL = "webapi/user/SyncUserRecord";
    return axios.post(serverRouterURL, SyncUser, APISetting);
  },
  getLeavebalasoftoday(obj) {
    return httpClient.post(endPoints.getLeavebalasoftoday, obj);
  }
};

export default UserService;



// WEBPACK FOOTER //
// ./src/service/UserService.js